import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import AcedSelect, {
  SelectOptions,
} from "../../../components/essentials/input/select/AcedSelect";

const SelectCartellinoPref = () => {
  const { t } = useTranslation();

  const rightsOptions: SelectOptions = [
    {
      value: "free",
      label: t("cartellinoPref.free"),
    },
    {
      value: "registered",
      label: t("cartellinoPref.registered"),
    },
    {
      value: "loan",
      label: t("cartellinoPref.loan"),
    },
    {
      value: "own",
      label: t("cartellinoPref.own"),
    },
    {
      value: "none",
      label: t("cartellinoPref.none"),
    },
  ];

  const { control } = useFormContext();

  return (
    <>
      <AcedSelect
        label={t("cartellinoPref.label")}
        options={rightsOptions}
        name="cartellinoStatus"
        control={control}
        rules={{ required: t("createJob.validation.required") }}
      />
    </>
  );
};

export default SelectCartellinoPref;
